import { LitElement } from 'lit';
export class FunctionalElementBaseClass extends LitElement {
}
